import {
  getSrvcList,
  getMarketCommonCode,
  getFHIRCodes,
  getCommonCode,
} from '@/api/commonApi';
import {
  COMMON_GROUP_CODE,
  MARKET_COMMON_GROUP_CODE,
  MARKET_COMMON_BANNER_TYPE_CODE,
  FHIR_RESOURCE_TYPE_CODE,
} from '../properties';

export default {
  namespaced: true,
  state: {
    goodsCnTypeCode: [],
    srvcList: [], // 서비스 목록
    bannerTypeCode: [],
    fhirCodes: [],
    fhirResrceTys: [],
    phrCodeSysTys: [],
  },
  actions: {
    // 마켓 공통코드 가져오기 : 컨텐츠 유형 코드
    async FETCH_GOOD_CN_TYPE_CODE(context) {
      const response = await getMarketCommonCode(
        MARKET_COMMON_GROUP_CODE.GOODS_CN_TYPE_CODE,
      );
      context.commit('SET_GOOD_CN_TYPE_CODE', response.data);
      return response;
    },
    // 서비스 목록 가져오기
    async FETCH_SRVC_LIST(context) {
      const response = await getSrvcList();
      context.commit('SET_SRVC_LIST', response.data);
      return response;
    },

    // 마켓 배너 타입 목록 가져오기 :
    async FETCH_BANNER_TYPE_CODE(context) {
      const response = await getMarketCommonCode(
        MARKET_COMMON_BANNER_TYPE_CODE,
      );
      context.commit('SET_BANNER_TYPE_CODE', response.data);
      return response;
    },
    /**
     * FHIR CODE 목록 조회
     * @param {*} context
     * @returns
     */
    async FETCH_FHIR_CODES(context) {
      const response = await getFHIRCodes();
      context.commit('SET_FHIR_CODES', response.data);
      return response;
    },
    /**
     * FHIR Resource 유형 목록 조회
     * @param {*} context
     * @returns
     */
    async FETCH_FHIR_RESOURCE_TYPES(context) {
      const response = await getCommonCode(
        COMMON_GROUP_CODE.CODE_FHIR_RESOURCE_TYPE,
      );
      context.commit('SET_FHIR_RESOURCE_TYPES', response.data);
      return response;
    },
    /**
     * PHR Code System 유형 목록 조회
     * @param {*} context
     * @returns
     */
    async FETCH_PHR_CODE_SYSTEM_TYPES(context) {
      const response = await getCommonCode(
        COMMON_GROUP_CODE.CODE_PHR_CODE_SYSTEM_TYPE,
      );
      context.commit('SET_PHR_CODE_SYSTEM_TYPES', response.data);
      return response;
    },
  },
  getters: {
    getBnrType: state => state.bannerTypeCode,
    // Observation FHIR 코드 목록
    observationFhirCodes: state =>
      state.fhirCodes.filter(
        fhirCode =>
          fhirCode.resrceTyCode === FHIR_RESOURCE_TYPE_CODE.OBSERVATION,
      ),
    // Encounter FHIR 코드 목록
    encounterFhirCodes: state =>
      state.fhirCodes.filter(
        fhirCode => fhirCode.resrceTyCode === FHIR_RESOURCE_TYPE_CODE.ENCOUNTER,
      ),
  },
  mutations: {
    SET_GOOD_CN_TYPE_CODE(state, data) {
      state.goodsCnTypeCode = data;
    },
    SET_BANNER_TYPE_CODE(state, data) {
      state.bannerTypeCode = data;
    },
    SET_SRVC_LIST(state, data) {
      const srvcList = data.map(val => {
        return {
          srvcId: val.srvcId,
          srvcNm: val.srvcNm,
        };
      });
      state.srvcList = srvcList;
    },
    SET_FHIR_CODES(state, data) {
      state.fhirCodes = data;
    },
    SET_FHIR_RESOURCE_TYPES(state, data) {
      state.fhirResrceTys = data;
    },
    SET_PHR_CODE_SYSTEM_TYPES(state, data) {
      state.phrCodeSysTys = data;
    },
  },
};
